export default "__VITE_ASSET__tmpTpZO8__"